"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marmentino": {
    "209f5ee0": [{
      "hkey": "bebda400",
      "slug": "dosso-ville",
      "name": "Dosso-Ville",
      "primary": true,
      "skipSearch": false
    }],
    "dosso": [{
      "hkey": "bebda400",
      "slug": "dosso-ville",
      "name": "Dosso-Ville",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "marmentino"
    }],
    "7c12b647": [{
      "hkey": "a5c01fc1",
      "slug": "vaghezza",
      "name": "Vaghezza",
      "primary": true,
      "skipSearch": false
    }],
    "piani-di-vaghezza": [{
      "hkey": "a5c01fc1",
      "slug": "vaghezza",
      "name": "Vaghezza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c9afd8ae": [{
      "hkey": "bebda400",
      "slug": "dosso-ville",
      "name": "Dosso-Ville",
      "primary": true,
      "skipSearch": false
    }],
    "ville": [{
      "hkey": "bebda400",
      "slug": "dosso-ville",
      "name": "Dosso-Ville",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "marmentino"
    }]
  }
};
exports["default"] = _default;